/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateInstrumentSelectionRequest} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/instrument_selection.pb'
import {InitiateInstrumentSelectionResponse} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/instrument_selection.pb'


export const initiateInstrumentSelection = (request: InitiateInstrumentSelectionRequest, options?: CashRequestOptions) => post<InitiateInstrumentSelectionRequest, InitiateInstrumentSelectionResponse>("/2.0/cash/initiate-instrument-selection", request, {...options, rejectOnError: true })